import React, { forwardRef } from 'react';
import { StatusProps, StatusState, StatusVariant, StatusType } from './Status.types';
import { statusVariants, dotVariants, statusColorMap, textClasses } from './Status.style';
import { cn } from '@/lib/styleUtils';

export const Status = forwardRef<HTMLSpanElement, StatusProps>(
  (
    {
      status = StatusState.neutral,
      variant = StatusVariant.primary,
      type = StatusType.text,
      text,
      className,
      showDot = true,
    },
    ref
  ) => {
    const colors = statusColorMap[status];
    const showBg = variant === StatusVariant.primary && type === StatusType.text;

    return (
      <span
        ref={ref}
        className={cn(statusVariants({ variant, type }), showBg && colors.bg, className)}
        data-cy="status-badge"
      >
        {showDot && (
          <span
            className={cn(dotVariants({ type }), colors.dot, type === StatusType.icon && className)}
            aria-hidden="true"
          />
        )}
        {type === StatusType.text && text && (
          <span className={cn(textClasses, colors.text)}>{text}</span>
        )}
      </span>
    );
  }
);

Status.displayName = 'Status';
